import React from 'react';
import { ActionProps } from 'react-querybuilder';

export const AddRuleAction = ({ props }: { props: ActionProps }) => {
    const handleOnClick = (e: React.MouseEvent) => {
        props.context.handleShowRules(true);
        props.handleOnClick(e);
    };

    return (
        <button
            type="button"
            className="rd-btn rd-btn--primary rd-btn--medium"
            onClick={handleOnClick}
            title={props.title}
            disabled={!props.context.fieldsReady}
        >
            {props.label}
        </button>
    );
};

export default AddRuleAction;
